import { useEffect } from 'react';

/**
 * Moves focus to the page heading (`#page-heading`, `tabIndex={-1}`, see `PageHeader`) each time
 * `token` increases past zero.
 *
 * For a page whose action removes the element that held focus: archiving or restoring a library card
 * closes the confirmation dialog, the card then disappears, and focus would fall to `<body>` — the
 * keyboard user restarts from the top of the document with no context. The heading is a stable,
 * meaningful landing place, and the page's own success status is announced separately (`role="status"`).
 *
 * The effect runs after the dialog's focus trap has restored focus to its (removed) trigger, so the
 * heading wins. A token of `0` never moves focus (initial render).
 */
export function useFocusPageHeading(token: number): void {
  useEffect(() => {
    if (token <= 0) return;
    document.getElementById('page-heading')?.focus();
  }, [token]);
}
